import React from "react";
import { Stack, Paper, Typography, Box, Skeleton, alpha } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EventBusyIcon from "@mui/icons-material/EventBusy";

const KPIS = [
  {
    key: "totalTasks",
    label: "Total",
    icon: AssignmentIcon,
    color: "#6366F1",
    gradient: "linear-gradient(135deg, #667EEA 0%, #764BA2 100%)",
  },
  {
    key: "totalPending",
    label: "Pending",
    icon: PendingActionsIcon,
    color: "#D97706",
    gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
  },
  {
    key: "totalInProgress",
    label: "In Progress",
    icon: HourglassTopIcon,
    color: "#1E40AF",
    gradient: "linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)",
  },
  {
    key: "totalCompleted",
    label: "Completed",
    icon: CheckCircleOutlineIcon,
    color: "#059669",
    gradient: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
  },
  {
    key: "totalOverdue",
    label: "Overdue",
    icon: EventBusyIcon,
    color: "#DC2626",
    gradient: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
  },
];

function KpiCard({ icon: Icon, label, value, color, gradient }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        flex: 1,
        minWidth: 140,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: -8,
          right: -8,
          width: 60,
          height: 60,
          borderRadius: "50%",
          bgcolor: alpha(color, 0.08),
        }}
      />
      <Stack spacing={0.5}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: 2,
              background: gradient,
              color: "white",
            }}
          >
            <Icon sx={{ fontSize: 18 }} />
          </Box>
          <Typography variant="caption" fontWeight={600} color="text.secondary">
            {label}
          </Typography>
        </Stack>
        <Typography variant="h5" fontWeight={800} sx={{ color }}>
          {value ?? 0}
        </Typography>
      </Stack>
    </Paper>
  );
}

export default function TasksKpis({ stats, loading }) {
  if (loading) {
    return (
      <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ rowGap: 2 }}>
        {KPIS.map((k) => (
          <Skeleton key={k.key} variant="rounded" height={90} sx={{ flex: 1, minWidth: 140, borderRadius: 3 }} />
        ))}
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ rowGap: 2 }}>
      {KPIS.map((k) => (
        <KpiCard
          key={k.key}
          icon={k.icon}
          label={k.label}
          value={stats?.[k.key]}
          color={k.color}
          gradient={k.gradient}
        />
      ))}
    </Stack>
  );
}
